<template>
  <div class="basic-info">
    <el-form
      label-position="left"
      label-width="6rem"
      :rules="rules"
      :model="groupInfo"
      v-if="isEdit&&operation=='create'"
    >
      <div class="edit-view">
        <div class="title">
          <div v-if="operation=='create'">添加新权限组</div>
          <div v-else>基本信息</div>
        </div>
        <el-form-item label="是否开启" >
          <el-radio-group v-model="groupInfo.status">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <!-- <el-tooltip placement="top" popper-class="custom-tooltip" effect="light">
            <div slot="content">
              <div class="custom-tip">默认标签由系统创建，只有超级管理员拥有对该标签的创建、修改和删除权限。</div>
              <div class="custom-tip">非默认标签由用户创建，拥有相应的权限即可对该标签进行增删改查的操作</div>
            </div>
            <svg-icon class="tip-svg" icon-class="tip" />
          </el-tooltip> -->
        </el-form-item>
        <el-form-item label="是否可公开" >
          <el-radio-group v-model="groupInfo.isPublic">
            <el-radio :label="true">公开</el-radio>
            <el-radio :label="false">不公开</el-radio>
          </el-radio-group>
          <el-tooltip placement="top" popper-class="custom-tooltip" effect="light">
            <div slot="content">
              <div class="custom-tip">公开：所有人员可见</div>
              <div class="custom-tip">私有：仅自己可见</div>
            </div>
            <svg-icon class="tip-svg" icon-class="tip" />
          </el-tooltip>
        </el-form-item>
        <el-form-item label="权限组名称" class="auto-height" prop="name">
          <el-input v-model="groupInfo.name" clearable placeholder="请输入权限组名称"></el-input>
          <div class="name-tip">仅支持中文、英文、数字、_、-，不超过30个字符</div>
        </el-form-item>

        <el-form-item label="权限组描述" class="auto-height">
          <el-input
            type="textarea"
            v-model="groupInfo.description"
            maxlength="200"
            show-word-limit
            clearable
            resize="none"
          ></el-input>
          <div class="name-tip">仅支持中文、英文、数字、_、-，不超过200个字符</div>
        </el-form-item>
        <div class="group-btn">
          <el-button type="primary" @click="editInfo">保存</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </div>
    </el-form>
    <el-form
      label-position="left"
      label-width="6rem"
      :rules="rules"
      :model="groupUpdataInfo"
      v-else-if="isEdit&&operation!=='create'"
    >
      <div class="edit-view">
        <div class="title">
          <div>基本信息</div>
        </div>
        <el-form-item label="是否开启" >
          <el-radio-group v-model="groupUpdataInfo.status">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
          <!-- <el-tooltip placement="top" popper-class="custom-tooltip" effect="light">
            <div slot="content">
              <div class="custom-tip">默认标签由系统创建，只有超级管理员拥有对该标签的创建、修改和删除权限。</div>
              <div class="custom-tip">非默认标签由用户创建，拥有相应的权限即可对该标签进行增删改查的操作</div>
            </div>
            <svg-icon class="tip-svg" icon-class="tip" />
          </el-tooltip> -->
        </el-form-item>
        <el-form-item label="是否可公开" >
          <el-radio-group v-model="groupUpdataInfo.isPublic">
            <el-radio :label="true">公开</el-radio>
            <el-radio :label="false">不公开</el-radio>
          </el-radio-group>
          <el-tooltip placement="top" popper-class="custom-tooltip" effect="light">
            <div slot="content">
              <div class="custom-tip">公开：所有人员可见</div>
              <div class="custom-tip">私有：仅自己可见</div>
            </div>
            <svg-icon class="tip-svg" icon-class="tip" />
          </el-tooltip>
        </el-form-item>
        <el-form-item label="权限组名称" class="auto-height" prop="name">
          <el-input v-model="groupUpdataInfo.name" clearable placeholder="请输入权限组名称"></el-input>
          <div class="name-tip">仅支持中文、英文、数字、_、-，不超过30个字符</div>
        </el-form-item>

        <el-form-item label="权限组描述" class="auto-height">
          <el-input
            type="textarea"
            v-model="groupUpdataInfo.description"
            maxlength="200"
            show-word-limit
            clearable
            resize="none"
          ></el-input>
          <div class="name-tip">仅支持中文、英文、数字、_、-，不超过200个字符</div>
        </el-form-item>
        <div class="group-btn">
          <el-button type="primary" @click="editInfo">保存</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </div>
    </el-form>
    <el-form
      label-position="left"
      label-width="6rem"
      :rules="rules"
      :model="groupUpdataInfo"
      v-else
    >
      <div class="info-view">
        <div class="title">
          {{groupInfo.name}}
          <div class="edit-btn" @click="updateInfo">管理</div>
        </div>
        <el-form-item label="是否开启">{{groupInfo.status?"开启":"关闭"}}</el-form-item>
        <el-form-item label="是否可公开">{{groupInfo.isPublic?"公开":"不公开"}}</el-form-item>
        <el-form-item label="权限组名称">{{groupInfo.name}}</el-form-item>
        <el-form-item label="权限组描述">{{groupInfo.description|nullValue}}</el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { creatRoles, updateRoles } from "@/http/api/role";
import { deepCopy } from "@/utils/deepCopy";


export default {
  props: {
    operation: { type: String }, //操作类型
    groupInfo: { type: Object }, // 权限组数据
  },
  data() {
    return {
      isEdit: false,
      groupUpdataInfo: this.groupInfo,
      rules: {
        name: [
          { required: true, message: "请输入权限组名称", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
      },
      permissionList: this.$store.getters.permissions, //用户权限集合
    };
  },
  watch: {
    operation(newV, oldV) {
      if (newV == "create") {
        this.isEdit = true;
      }
      //console.log(newV, oldV);
    },
    groupInfo(newVal, oldVal) {
      this.groupUpdataInfo = deepCopy(this.groupInfo);
    },
  },
  mounted() {
    //console.log(this.groupInfo, "zhelishigroupInfo");
  },
  methods: {
    updateInfo() {
      //console.log(this.isEdit,'修改权限');
      if (this.permissionList["RocketIdentity.Roles.Update"]) {
        this.isEdit = true;
        var data = deepCopy(this.groupInfo);
        this.groupUpdataInfo = {
          concurrencyStamp: data.concurrencyStamp,
          name: data.name,
          isDefault: data.isDefault,
          isPublic: data.isPublic,
        };
      } else {
        this.$message.warning({
          message: `您暂无管理权限组权限`,
          showClose: true,
        });
      }
    },
    editInfo() {
      this.isEdit = false;
      if (this.operation == "create") {
        creatRoles(this.groupInfo)
          .then((res) => {
            if (res.code == 10200) {
              this.$emit("createPermission", this.groupInfo);
              this.$message.success({ message: res.message });
            } else {
              this.$message.warning({ message: res.message });
            }
          })
          .catch((err) => {
            this.$message.error({ message: err.message });
          });
      } else {
        //console.log(this.groupUpdataInfo, "获取的this.groupUpdataInfo");

        updateRoles(this.groupInfo.id, this.groupUpdataInfo)
          .then((res) => {
            if (res.code == 10200) {
              this.$emit("createPermission", this.groupInfo);
              this.$message.success({ message: res.message });
            } else {
              this.$message.warning({ message: res.message });
            }
          })
          .catch((err) => {
            this.$message.error({ message: err.message });
          });
      }
    },
    cancel() {
      this.isEdit = false;
      this.$emit("createPermission", this.groupInfo);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.basic-info {
  padding: 20px;
  text-align: left;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin: 20px 0;
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
    color: #000;

    .edit-btn {
      position: relative;
      z-index: 500;
      font-size: 12px;
      font-weight: 400;
      color: $--color-primary;
      cursor: pointer;
    }
  }
  .info-view {
    .el-form-item {
      margin-bottom: 2px;
    }
  }

  .edit-view {
    .el-form-item {
      margin-bottom: 20px;
      width: 425px;

      .name-tip {
        margin-top: 7px;
        font-size: 12px;
        font-weight: 400;
        line-height: 14px;
        color: #888;
      }
      // ::v-deep .el-form-item__content{
      //   @include flex (row,center);
      // }
      .tip-svg {
        position: relative;
        top: -1px;
        margin-left: 5px;
        width: 14px;
        height: 14px;
        color: #9e9e9e;
      }
    }

    .group-btn {
      margin: 12px 0 0 6rem;
    }
  }
}
// ::v-deep .custom-tooltip {
//   .custom-tip {
//     padding: 5px;
//   }
// }
</style>